import request, { gql } from 'graphql-request';

// const LOGIN = gql`
//   mutation Login($email: String!, $password: String!) {
//     tokenAuth(email: $email, password: $password) {
//       success
//       errors
//       token
//       refreshToken
//       user {
//         id
//         email
//         username
//         firstName
//         lastName
//         teamLeader
//         empoloyeeid
//         roleStatus
//         department
//         designation
//         address
//         login
//         logout
//         isActive
//       }
//     }
//   }
// `;

const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    tokenAuth(email: $email, password: $password) {
      success
      errors
      token
      refreshToken
      user {
        id
        email
        username
        firstName
        lastName
        role
        empid
        isActive
      }
    }
  }
`;

export { LOGIN };

const CHANGE_PASSWORD = gql`
mutation ChangePassword(
  $token:String!
  $newPassword1: String!
  $newPassword2: String!
){
  passwordReset(token: $token, newPassword1: $newPassword1, newPassword2: $newPassword2){
    success
    errors
  }
}`;
export {CHANGE_PASSWORD};

// mutation ForgotPassword(
//   $email:String!
// ){
//   sendPasswordResetEmail(email: $email){
//     success
//     errors
//   }
// }
const FORGOT_PASSWORD = gql`
  mutation password_reset_mutation($email: String!){
  resetPasswordMail(email:$email){
    message
    success
    error
  }
}

  
`;
export{FORGOT_PASSWORD}


const ALL_USERS = gql`
query userDetails($search:String!,$skip:Int!,$first:Int!,$orderBy:[String!]){
  userDetails(search:$search,skip:$skip,first:$first,orderBy:$orderBy){
    id
    email
    username
    empoloyeeid
    department
    designation
    teamLeader
    roleStatus
    isActive
    dob
    address
    contactno
    leavebalance
    actualSalary
    bloodGroup
    emergencyContactNumber
    dateJoined
    login
    logout
    
  }
}
`;
export {ALL_USERS}